import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  backButton: {
    backgroundColor: "#f7c948",
    boxShadow: "0px 3px 6px #00000029",
    padding: "1vh 1vw",
    outline: "none",
    textDecoration: "none",
    border: "none",
    borderRadius: "6px",
    color: "white",
    marginBottom: "1%"
  },
}));
const Summary = ({ loading, dailyHooks, monthlyHooks, totalHooks }) => {
  const classes = useStyles();

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const handleBackButtonClick = () => {
    window.history.back();
  };
  return (
    <div>
      <div>
        <button onClick={handleBackButtonClick} className={classes.backButton}>
          Back
        </button>
      </div>
      <div className="audit-tabs">
        <div className="item">
          <div className="label">Daily Hook</div>
          <div className="value">
            {loading ? <CircularProgress /> : numberWithCommas(dailyHooks)}
          </div>
        </div>

        <div className="item">
          <div className="label">Monthly Hooks</div>
          <div className="value">
            {loading ? <CircularProgress /> : numberWithCommas(monthlyHooks)}
          </div>
        </div>

        <div className="item">
          <div className="label">Yearly Hooks</div>
          <div className="value">
            {loading ? <CircularProgress /> : numberWithCommas(totalHooks)}
          </div>
        </div>

        <div className="item">
          <div className="label">Total Hooks</div>
          <div className="value">
            {loading ? <CircularProgress /> : numberWithCommas(totalHooks)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summary;
